import React from "react";
import Fade from "react-reveal/Fade";
import "./ServiceCard.scss";

interface ServiceCardProps {
  title: string;
  description: string;
  icon?: string;
}

const ServiceCard = (props: ServiceCardProps) => {
  const { title, description, icon } = props;
  return (
    <Fade bottom>
      <div className="col-xl-3 col-lg-6 col-md-6 col-sm-12 mt-5">
        <div className="service">
          <div className="inner">
            <div className="icon">
              <i className={icon}></i>
            </div>
            <div className="content">
              <h1 className="title">{title}</h1>
              <p className="description">{description}</p>
            </div>
          </div>
        </div>
      </div>
    </Fade>
  );
};

export default ServiceCard;
